/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbExternalEhrDocument } from './HchbExternalEhrDocument';
import {
    HchbExternalEhrDocumentFromJSON,
    HchbExternalEhrDocumentFromJSONTyped,
    HchbExternalEhrDocumentToJSON,
} from './HchbExternalEhrDocument';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    processing_error?: string;
    /**
     * 
     * @type {HchbExternalEhrDocument}
     * @memberof Document
     */
    external_ehr_document?: HchbExternalEhrDocument;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'processing_error': !exists(json, 'processing_error') ? undefined : json['processing_error'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : HchbExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function DocumentToJSON(value?: Document | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        's3_key': value.s3_key,
        'processing_error': value.processing_error,
        'external_ehr_document': HchbExternalEhrDocumentToJSON(value.external_ehr_document),
    };
}

